
import Vue from "vue";
import TopBar from "@/components/navigation/TopBar.vue";
import SideBar from "@/components/navigation/SideBar.vue";
import UserMenu from "@/components/navigation/UserMenu.vue";

export default Vue.extend({
  data: () => ({
    showUserMenu: false,
  }),
  components: {
    TopBar,
    SideBar,
    UserMenu,
  },
  methods: {
    toggleUserMenu() {
      this.showUserMenu = !this.showUserMenu;
    },
  },
});
